import AsyncGroupFactory from '@/Factories/AsyncGroupFactory';
import ComponentManager from '@/Management/ComponentManager';
import DetailViewGroupBoxViewModelT from '@/ViewModels/Controls/DetailViewGroupBoxViewModel';
import DetailViewGroupBoxT from '@/Controls/DetailViewGroupBox';
import {DisposeBehavior} from '#/DefaultViewExtensionInterfaces';

export default class DetailViewGroupFactory extends AsyncGroupFactory {

    private DetailViewGroupBoxViewModel = ComponentManager.getViewModel<typeof DetailViewGroupBoxViewModelT>('DetailViewGroupBoxViewModel');
    private DetailViewGroupBox = ComponentManager.getControl<typeof DetailViewGroupBoxT>('DetailViewGroupBox');

    /**
     * @override
     */
    viewModel: DetailViewGroupBoxViewModelT;

    /**
     * @override
     */
    control: DetailViewGroupBoxT;

    public constructor(params: any) {
        super(params);
    }

    /**
     * @override 
     */
    protected createViewModel(): DetailViewGroupBoxViewModelT {
        return new this.DetailViewGroupBoxViewModel({
            context: this.context,
            layout: this.layout,
            isSummaryViewMode: this.isSummaryViewMode,
            parentLocator: this.locator,
            locator: (this.detailViewGroup as any).typeName, // TODO: typeName nicht verfügbar, überhaupt gesetzt?
            detailViewGroups: this.detailViewGroup.detailViewGroups
        });
    }

    /**
     * @override 
     */
    protected createControl(): DetailViewGroupBoxT {
        return new this.DetailViewGroupBox(this.viewModel);
    }

    public onAfterRender() {
        this.control.onAfterRender();
    }

    protected getDisposeBehavior(): DisposeBehavior {
        return "Asynchronous";
    }
}

ComponentManager.setFactory('DetailViewGroup', DetailViewGroupFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');